class Instance {
    constructor(_instanceId, _request) {
        this.request = _request;
        this.instanceId = _instanceId;
    }

    assign_workers(_workers, _delay) {
        return this.request.fetch({
            method: "PUT",
            endpoint: `instance/${this.instanceId}/assign-workers`,
            params: {
                workers: _workers,
                delay: _delay
            }
        });
    }

    details() {
        return this.request.fetch({
            method: "GET",
            endpoint: `instance/${this.instanceId}`
        });
    }

    delete() {
        return this.request.fetch({
            method: "DELETE",
            endpoint: `instance/${this.instanceId}`
        });
    }

    redirect_workers(_workers, _delay) {
        return this.request.fetch({
            method: "PUT",
            endpoint: `instance/${this.instanceId}/redirect`,
            params: {
                workers: _workers,
                delay: _delay
            }
        });
    }

    archive() {
        return this.request.fetch({
            method: "PUT",
            endpoint: `instance/${this.instanceId}/archive`
        });
    }

    remove_workers(_workers) {
        return this.request.fetch({
            method: "PUT",
            endpoint: `instance/${this.instanceId}/remove-workers`,
            params: {
                workers: _workers
            }
        });
    }

    deploy_subprocess(_data) {
        return this.request.fetch({
            method: "POST",
            endpoint: `instance/${this.instanceId}/create-sub-process`,
            params: _data
        });
    }
}

export default Instance;
